import React from 'react'
import {Image} from 'antd';
import Img1 from "./3dmodel1.jpg"
import Img2 from "./3dmodel2.jpg"
import Img3 from "./3dmodel3.jpg"
import Img4 from "./3dmodel4.jpg"
import Img5 from "./3dmodel5.jpg"
import Img6 from "./3dmodel6.jpg"
import Img7 from "./3dmodel7.jpg"
import Img8 from "./3dmodel8.jpg"
import Img9 from "./3dmodel9.jpg"
import Img10 from "./3dmodel10.jpg"
import Img11 from "./3dmodel11.jpg"
import Img12 from "./3dmodel12.jpg"
import Img13 from "./3dmodel13.jpg"
import Img14 from "./3dmodel14.jpg"
import Img15 from "./3dmodel15.jpg"
import Img16 from "./3dmodel16.jpg"
import Img17 from "./3dmodel17.jpg"
import Img18 from "./3dmodel18.jpg"
import Img19 from "./3dmodel19.jpg"
import Img20 from "./3dmodel20.jpg"
import Img21 from "./3dmodel21.jpg"
import Img22 from "./3dmodel22.jpg"
import Img23 from "./3dmodel23.jpg"
import Img24 from "./3dmodel24.jpg"
import Img25 from "./3dmodel25.jpg"
import Img26 from "./3dmodel26.jpg"
const width = 1280;

export default function Model() {
  return (
    <Image.PreviewGroup>
    <Image width={width} src={Img1} />
    <Image width={width} src={Img2} />
    <Image width={width} src={Img3} />
    <Image width={width} src={Img4} />
    <Image width={width} src={Img5} />
    <Image width={width} src={Img6} />
    <Image width={width} src={Img7} />
    <Image width={width} src={Img8} />
    <Image width={width} src={Img9} />
    <Image width={width} src={Img10} />
    <Image width={width} src={Img11} />
    <Image width={width} src={Img12} />
    <Image width={width} src={Img13} />
    <Image width={width} src={Img14} />
    <Image width={width} src={Img15} />
    <Image width={width} src={Img16} />
    <Image width={width} src={Img17} />
    <Image width={width} src={Img18} />
    <Image width={width} src={Img19} />
    <Image width={width} src={Img20} />
    <Image width={width} src={Img21} />
    <Image width={width} src={Img22} />
    <Image width={width} src={Img23} />
    <Image width={width} src={Img24} />
    <Image width={width} src={Img25} />
    <Image width={width} src={Img26} />
    </Image.PreviewGroup>
  )
}